import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import RelatedLinks from "../RelatedLinks";
import { SecondAds,    FirstAds , MobileUnderCalAds } from "../../Ads";
import SharedHelmet from '../Helmet';
const TITLE = "Calculatrice des effets de la dépendance sur la santé et l'espérance de vie - Outils de sevrage";
const DESCRIPTION =
  "Calculatrice des effets de la dépendance sur la santé et l en francais pour estimer vos indicateurs de sante rapidement. Entrez vos donnees et obtenez un resultat clair avec des reperes utiles pour le suivi quotidien.";
const KEYWORDS =
  "des effets de la dépendance sur la santé et l, calculatrice des effets de la dépendance sur la santé et l, calcul en ligne, sante, bien-etre, indicateurs sante, resultat rapide";
const OG_URL = "https://do-calculate.com/calculator/fr/addiction-calculator/";
function AddictionCalculator() {
  const [age, setAge] = useState(0);
  const [dailyDose, setDailyDose] = useState(0);
  const [addictionType, setAddictionType] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const addictionData = {
    "Tabagisme": { yearsLost: 10, lifeExpectancy: 79 - 10 },
    "Alcool": { yearsLost: 23, lifeExpectancy: 79 - 23 },
    "Cocaïne": { yearsLost: 34, doseEffect: 5.6, lifeExpectancy: 79 - 34 },
    "Méthadone": { yearsLost: 38, lifeExpectancy: 41 },
    "Héroïne": { yearsLost: 42, lifeExpectancy: 38 },
    "Méthamphétamine": { yearsLost: 42, doseEffect: 11, lifeExpectancy: 79 - 42 },
  };
  const handleCalculate = () => {
    try {
      if (age && dailyDose && addictionType) {
        const addiction = addictionData[addictionType];
        if (addiction) {
          const nonAddictLifeExpectancy = 79;
          const lifeExpectancy = addiction.lifeExpectancy;
          const yearsLost = nonAddictLifeExpectancy - lifeExpectancy;
          const totalDoseEffect = addiction.doseEffect
            ? dailyDose * addiction.doseEffect
            : 0;
          const addictionDuration =
            age > lifeExpectancy ? 0 : lifeExpectancy - age;
          const totalLifeLost = yearsLost + totalDoseEffect;
          setResult({
            nonAddictLifeExpectancy,
            lifeExpectancy,
            addictionDuration,
            totalLifeLost,
          });
        }
      }
    } catch (error) {
      setError(error.message);
    }
  };
  return (
    <div className="ltr">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  Cette calculatrice calcule l'espérance de vie en fonction du type de
                  dépendance et du nombre de doses quotidiennes.
                </p>
                <p>
                  Vous êtes-vous déjà demandé quel est le vrai prix de la dépendance?
                  Cet outil vous aide à estimer certains des effets sanitaires potentiels
                  à long terme de la dépendance. <strong>
                    Veuillez noter que ce ne sont que des estimations, et que l'espérance
                    de vie est affectée par de nombreux facteurs.{" "}
                  </strong>
                  La dépendance est une maladie complexe, et le traitement et les soins
                  de santé peuvent changer le cours de votre vie de manière significative.
                </p>
                <p>
                  La dépendance vous vole beaucoup plus que vous ne l'imaginez. Cet outil
                  vous fournit un aperçu des effets sanitaires potentiels de la dépendance.
                  Rappelez-vous que l'espérance de vie n'est qu'un chiffre, et que la qualité
                  de vie est la plus importante. La guérison est possible, et n'hésitez pas
                  à demander de l'aide.
                </p>
                <p>
                  <b>
                    Important: Il faut souligner que cette calculatrice n'est qu'un outil d'aide,
                    et ne doit pas être utilisée comme un diagnostic médical. Si vous souffrez
                    d'un problème de dépendance, vous devez consulter un médecin ou un spécialiste
                    en santé mentale.
                  </b>
                </p>
                <p>
                  La calculatrice a été développée sur la base du{" "}
                  <a
                    href="https://www.dailymail.co.uk/health/article-2788399/how-years-drinking-drug-smoking-habits-shaving-life-terrifying-graphic-reveals-one-cigarette-cuts-14-minutes-alcoholic-drink-cost-7-hours.html"
                    rel="nofollow"
                  >
                    quotidien Mail britannique
                  </a>
                </p>
                <hr />
              </div>
              <br />
            </div>
            <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div>
                  <div>
                    <hr />
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="age">
                        Entrez votre âge
                      </label>
                      <input
                        id="age"
                        type="number"
                        value={age}
                        onChange={(e) => setAge(e.target.value)}
                        placeholder="Entrez votre âge"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label className="form-label ms-2" htmlFor="dailyDose">
                        Nombre de doses quotidiennes
                      </label>
                      <input
                        id="dailyDose"
                        type="number"
                        value={dailyDose}
                        onChange={(e) => setDailyDose(e.target.value)}
                        placeholder="Entrez les doses quotidiennes"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group">
                      <label
                        className="form-label ms-2"
                        htmlFor="addictionType"
                      >
                        Choisir le type de dépendance
                      </label>
                      <select
                        id="addictionType"
                        value={addictionType}
                        onChange={(e) => setAddictionType(e.target.value)}
                        className="form-control"
                        style={{ width: "75%" }}
                      >
                        <option value="">Choisir le type de dépendance</option>
                        <option value="Tabagisme">Tabagisme</option>
                        <option value="Alcool">Alcool</option>
                        <option value="Cocaïne">Cocaïne</option>
                        <option value="Méthadone">Méthadone</option>
                        <option value="Héroïne">Héroïne</option>
                        <option value="Méthamphétamine">Méthamphétamine</option>
                      </select>
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      Calculer                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      Erreur: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success text-white">
                      <h4>Résultats:</h4>
                      <p>
                        Espérance de vie pour les non-dépendants:{" "}
                        {result.nonAddictLifeExpectancy} ans
                      </p>
                      <p>Espérance de vie pour les dépendants: {result.lifeExpectancy} ans</p>
                      <p>Durée de la dépendance: {result.addictionDuration} ans</p>
                      <p>Total des années perdues: {result.totalLifeLost} ans</p>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <hr />
            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ marginTop: "20px" }}>
        <div className="col-12 col-md-8">
  <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Conseils d'utilisation</h3></div>
              <div className="info-section-body">
                <p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p>
              </div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>Comprendre la dpendance</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
            <div className="info-section">
              <div className="info-section-header"><h3 style={{ fontSize: "16px" }}>valuation du risque</h3></div>
              <div className="info-section-body"><p>Pour obtenir un resultat pertinent, verifiez vos unites, saisissez des valeurs realistes et utilisez ce calcul comme aide a la decision, puis adaptez selon votre situation.</p></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AddictionCalculator;
